import { Component } from '@angular/core';

/* TODO - remove this - only for DEVEL */
import { isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-bio-page',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './bio-page.component.html',
    styleUrl: './bio-page.component.scss',
})
export class BioPageComponent {
    /* TODO - remove this - only for DEVEL */
    isDevMode: boolean = isDevMode();
}
